/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";

// clipboardCopy for mail variables
import clipboardCopy from "clipboard-copy";

// Material UI components
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";

/*import url and gateway methods */
import { getData, putData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import SurveyListFilterPopup from "../Popup/SurveyListFilterPopup";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import SuccessMessageModal from "../Modal/SuccessMessageModal";
import { assetImages } from "constants";
import { useTranslation } from "react-i18next";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import SaveSurveyModal from "../Modal/SaveSurveyModal";
import SurveyListHeader from "components/SurveyComponents/Header/SurveyListHeader";
import UpdateSurveyModal from "../Modal/UpdateSurveyModal";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";

const SurveyListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [surveyList, setSurveyList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedSurveyIds, setSelectedSurveyIds] = useState([]);

  const [selectedSurveyId, setSelectedSurveyId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const [filterSurveyName, setFilterSurveyName] = useState("");
  const [filterSurveyCode, setFilterSurveyCode] = useState("");
  const [filterSurveyDateRange, setfilterSurveyDateRange] = useState("");
  const [filterSurveyTags, setfilterSurveyTags] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  /* --- function to navigate to survey question --- */
  const getAllSurvey = async () => {
    setRowSelection({});
    setSelectedSurveyIds([]);

    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_SURVEY;

      if (filterSurveyName != "") {
        requestUrl = requestUrl + `&filtername=${filterSurveyName}`;
      }
      if (filterSurveyCode != "") {
        requestUrl = requestUrl + `&filtercode=${filterSurveyCode}`;
      }
      if (filterSurveyDateRange != "") {
        requestUrl = requestUrl + `&filterdates=${filterSurveyDateRange}`;
      }
      if (filterSurveyTags.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterSurveyTags}`;
      }

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("response in survey list------->", response);

      if (response.status) {
        setSurveyList(response.data);

        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  // get survey by filter
  const getSurveyByFilter = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_SURVEY;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setSurveyList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);

      setIsLoading(false);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for delete survey
  const deleteMassiveSurveyHandler = async () => {
    if (selectedSurveyIds.length > 0) {
      const surveyListToBeDelete = surveyList.filter((item) =>
        selectedSurveyIds.includes(item._id)
      );

      try {
        let surveyData = {
          surveylist: surveyListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_MASSIVE_SURVEY;

        const response = await putData(requestURL, surveyData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            getAllSurvey();
          }, 2500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }

      setShowAlert(true);
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one course");
      setShowAlert(true);
    }
  };

  //reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  //copy url function
  const copyUrlHandler = (surveyCode = "") => {
    if (surveyCode !== "") {
      let copiedUrl = `${url.BACKEND_BASE_URL}/survey/${surveyCode}`;

      clipboardCopy(copiedUrl);

      setAlertMessage(t("Url copied successfully"));
      setMessageType("success");
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (reloadData) {
      getAllSurvey();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getSurveyByFilter();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllSurvey();
  }, []);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: t("Name"),
        size: 300,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div className="action border-bottom-0">
              <span>{row.original.name}</span>
            </div>
            <Link
              to="#"
              className="d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#copyUpdateSurveyModal"
              onClick={() => {
                setSelectedSurveyId(row.original._id);
                setIsEdit(true);
              }}
            >
              <span className="material-symbols-outlined icon-sm">edit</span>
            </Link>
            <Link
              to="#"
              className="d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#copyUpdateSurveyModal"
              onClick={() => {
                setSelectedSurveyId(row.original._id);
                setIsEdit(false);
              }}
            >
              <span className="material-symbols-outlined icon-sm">
                content_copy
              </span>
            </Link>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                copyUrlHandler(row.original.code);
              }}
            >
              Copy Url
            </button>
          </Box>
        ),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        Cell: ({ row }) => (
          <div className="label border-bottom-0">
            {row.original.tagstring != "" && (
              <ul className="d-flex flex-wrap gap-2 fs-xs">
                {row.original.tagstring.split(" , ").map((tag, index) => {
                  return (
                    <li
                      key={index}
                      className="px-2 py-1 gradient-light rounded-5"
                    >
                      {tag}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ),
      },
      {
        accessorKey: "code",
        header: t("Code"),
      },
      {
        accessorKey: "modulename",
        header: t("Module"),
      },
      {
        accessorKey: "componentname",
        header: t("Component"),
      },
      {
        accessorKey: "moderatorname",
        header: t("Moderator"),
        size: 200,
        Cell: ({ row }) => (
          <div className="d-flex border-bottom-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "25px", height: "25px" }}
              >
                <img
                  src={
                    row.original.moderatorimage == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.moderatorimage
                  }
                  alt="admin"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <p>{row.original.moderatorname}</p>
            </div>
            <button
              onClick={() => {
                createContactChatHandler(
                  row.original.moderator,
                  "MOD_SURVEY",
                  row.original._id,
                  row.original.name
                );
              }}
              className={
                row.original.moderator?.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      {
        accessorKey: "surveyresponsecount",
        header: t("Responses"),
      },
      {
        accessorKey: "surveydate",
        header: t("Created Date"),
      },
    ],
    [i18n.language]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      const selectedSurveyIdArr = selectedIdsArray.map((id) => {
        const [surveyId] = id.split("|");
        return surveyId;
      });

      setSelectedSurveyIds(selectedSurveyIdArr);
    } else {
      setSelectedSurveyIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_SURVEY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* --- filter section start --- */}
            <SurveyListHeader
              reloadList={resetFilterData}
              deleteMassiveSurveyHandler={deleteMassiveSurveyHandler}
            />
            {/* --- filter section end --- */}

            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={surveyList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}|${row.moderatorid}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => {
                    const [surveyId, ownerId] = row.id.split("|"); // Extracts the _id part

                    const menuItems = [
                      <MenuItem key="#">
                        <Link
                          className="dropdown-item"
                          to={`/admin/survey/question/list/${surveyId}`}
                        >
                          {t("Save Question To Survey")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="#">
                        <Link
                          className="dropdown-item"
                          to={`/admin/survey/invite/list/${surveyId}`}
                        >
                          {t("Survey Invites")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="#">
                        <Link
                          className="dropdown-item"
                          to={`/admin/survey/response/list/${surveyId}`}
                        >
                          {t("Survey Responses")}
                        </Link>
                      </MenuItem>,
                    ];

                    if (
                      userInfo.role.slug === "ADMIN" ||
                      userInfo.role.slug === "SUPER_ADMIN" ||
                      ownerId.toString() === userInfo._id.toString()
                    ) {
                      return menuItems;
                    } else {
                      return [];
                    }
                  }} // action columns menu items
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* save survey modal */}
        <SaveSurveyModal
          afterModalClose={getAllSurvey}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        <UpdateSurveyModal
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          selectedSurveyId={selectedSurveyId}
          setSelectedSurveyId={setSelectedSurveyId}
          afterModalClose={getAllSurvey}
        />

        {/* succes modal */}
        <SuccessMessageModal afterModalClose={getAllSurvey} />

        {/* --- add label modal start --- */}
        <AddLabelModal
          moduleName="survey"
          selectedIds={selectedSurveyIds}
          afterTagModalClose={() => {
            setTimeout(() => {
              getAllSurvey();
            }, 2500);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />
        {/* --- add label modal end --- */}

        {/* --- filter popup --- */}
        <SurveyListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="surveylist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedSurveyIds([]);
          }}
          onDelete={deleteMassiveSurveyHandler}
          moduleName={t("survey")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default SurveyListBody;
